import { Team } from '@clearkit/icons';

import { PageLayout } from '~/components/PageLayout';
import { UserTeamSettings } from '~/components/profile/UserTeamSettings';

export const PageGeneralTeams = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <Team />
      </PageLayout.Tile>
      <PageLayout.Heading>My Teams</PageLayout.Heading>
      <PageLayout.SubHeading>Manage your teams</PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <UserTeamSettings />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
